import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getTermometroPendenciasAlunos(): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/termometro/geral/pendencias/', {});
  return data;
}

type QueryFnType = typeof getTermometroPendenciasAlunos;

function useTermometroPendenciasAlunos() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-geral-pendencias'],
    queryFn: getTermometroPendenciasAlunos,
  });
}

export { getTermometroPendenciasAlunos, useTermometroPendenciasAlunos };
